import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import FullWidthImage from './components/FullWidthImage/FullWidthImage';
import Features from './components/Features/Features';
import FAQ from './components/FAQ/FAQ';
import EmailSignup from './components/EmailSignup/EmailSignup';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <FullWidthImage imageSrc="/assets/WallImage.png" altText="LifeInPXL wall showcase" />
        <Features />
        <FullWidthImage imageSrc="/assets/FinalmidImage.png" altText="LifeInPXL mid showcase" />
        <FAQ />
        <EmailSignup />
      </main>
      <Footer />
    </div>
  );
}

export default App;

